import * as React from "react";
const SvgFiRrPlane = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane_svg__a)">
      <path
        fill="#062147"
        d="M21 10h-3.307l-4.247-8.437A3 3 0 0 0 10.812 0h-.182A2.63 2.63 0 0 0 8.1 3.361L10.028 10H7.644a2.98 2.98 0 0 1-2.122-.879L4.105 7.7a2.41 2.41 0 0 0-2.814-.433A2.32 2.32 0 0 0 .125 8.689a2.53 2.53 0 0 0 .228 1.966l1.614 2.825A5.01 5.01 0 0 0 6.307 16h3.712L8.35 20.447A2.63 2.63 0 0 0 10.81 24a2.97 2.97 0 0 0 2.606-1.513L17.464 16H21a3 3 0 0 0 0-6M10.025 2.805A.63.63 0 0 1 10.63 2h.182a.99.99 0 0 1 .863.491L15.455 10H12.11zM21 14h-4.091a1 1 0 0 0-.848.471l-4.371 7.008a1 1 0 0 1-.878.521.627.627 0 0 1-.588-.85l2.174-5.8A1 1 0 0 0 11.46 14H6.308a3 3 0 0 1-2.6-1.512L2.089 9.662a.52.52 0 0 1-.047-.4.32.32 0 0 1 .158-.211.415.415 0 0 1 .487.067l1.417 1.417A4.97 4.97 0 0 0 7.644 12H21a1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlane;
